module.exports = __webpack_public_path__ + "static/media/portalImg.edc3d276.jpg";